import { IControlBaseAttributes } from "../../../base/models";

export const CustomComponent = ({ control }: IControlBaseAttributes) => {
    if (!control) {
        return <div className="alert alert-danger">No component to show</div>
    }

    return <></>
}
